import React, { Component } from 'react'
import $ from 'jquery';
import slugify from 'slugify';
import qs from 'qs';
import { Col, Row } from 'reactstrap';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import ComplianceCard from './compliance-card'
import Control from '../controlGrid';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'

class LowLevelCategories extends Component {
    state = {
        categories: [],
        controls: [],
        loading: true,
        loaded: false,
        totalControls: 0,
        compliantControlsTotal: 0,
        selectedCategory: 0,
        scrolling: false,
        updateGrid: true,
        urlFrameworkName: null,
        highLevelCategory: null,
        humanHighLevelCategory: '',
        lowLevelCategory: null,
        isFlat: null,
        categoryCompliance: 0
    }

    signoutUser () {
        this.props.signout();
        this.props.history.push('/');
    }

    setUpdate = (title, active) => {
        this.setState({ updateGrid: (title !== active) })
    }

    selectNewCatagory (category, lowLevelCategory) {
        this.setState({ selectedCategory: category, lowLevelCategory: lowLevelCategory });
    }

    scrollContent (direction) {
        const step = 370;

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
        });
    }

    getCatInView (i) {
        const step = 370;
        let direction = 'right';

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step * i + "px"
        });
    }

    sortCardsAlphabetically(object1,object2){
        const obj1 = object1.name.toUpperCase()
        const obj2 = object2.name.toUpperCase()
        let comparison = 0
        if(obj1 > obj2){
            comparison = 1;
        }
        else if(obj1 < obj2){
            comparison = -1
        }
        return comparison
    }

    renderSlideCards () {
        return this.state.categories.map((category, i) => {

            let percentageCal = (category.numberOfControls - category.numberOfNotApplicableControls) >= 0 ?
                Number ((((category.numberOfCompliantControls + category.numberOfNotApplicableControls)/
                    (category.numberOfControls)) * 100).toFixed(0)) : 0;

            return <div key={category.name} style={{ marginRight: 20 }}>
                <ComplianceCard
                    id={i}
                    category={category.name}
                    percentage={percentageCal}
                    changeCategory={this.selectNewCatagory.bind(this)}
                    numberCompliance={category.numberOfCompliantControls + category.numberOfNotApplicableControls}
                    totalControls={category.numberOfControls}
                    clickable={true}
                    percentage_color={percentageCal > 0 ? "#2d9aa6" : "#C6C6C6"} //#3DA3FC
                    hoverColor={true}
                    isActive={this.state.selectedCategory === i ? true : false}
                    setUpdate={this.setUpdate}
                    bgColor="white-bg"
                    selectedCatName={this.state.categories[this.state.selectedCategory]}
                    isPercentage={true}
                    layout={this.props.layout}
                    safeguardID={category.safeguardID}
                />
            </div>
        })
    }

    componentDidMount () {
        const { categories, highLevelCategory } = this.props;
        let selectedHighLevelCategory = null
        let selectedCategory = 0
        let pageData = {
            categories: categories.sort(this.sortCardsAlphabetically),
        }

        if (highLevelCategory) {
            selectedHighLevelCategory = categories.find(c => slugify(c.name.toLowerCase()) === highLevelCategory);

            if (selectedHighLevelCategory) {

                //we redefine the page data to be the specific category
                let sortedCategories = selectedHighLevelCategory.categories.slice(0)
                try {
                    sortedCategories.sort((a, b) => {
                        if (a.lowLevelOrder && b.lowLevelOrder) {
                            return Number(a.lowLevelOrder) - Number(b.lowLevelOrder)
                        }
                        else {
                            return 0
                        }
                    })
                } catch (err) {
                }

                pageData.categories = sortedCategories
                pageData.totalControls = 
                    selectedHighLevelCategory.numberOfControls
                pageData.notApplicableControlsTotal = selectedHighLevelCategory.numberOfNotApplicableControls || 0
            }
        } else {
            pageData.totalControls =
                categories.reduce((prevNumberOfControls, currentCategory) =>
                    prevNumberOfControls +
                    (currentCategory.numberOfControls), 0)
            pageData.compliantControlsTotal =
                categories.reduce((prevNumberOfCompliantControls, currentCategory) =>
                    prevNumberOfCompliantControls + currentCategory.numberOfCompliantControls, 0)
            pageData.notApplicableControlsTotal =
                categories.reduce((prevNumberOfNotApplicableControls, currentCategory) =>
                    prevNumberOfNotApplicableControls + currentCategory.numberOfNotApplicableControls, 0)
        }

        //scrolls to url category
        try {
            const parsed = qs.parse(this.props.location.search.slice(1));
                if (parsed && parsed.category) {
                    pageData.categories.sort(this.sortCardsAlphabetically).map((category, i) => {

                        let slugifiedCatName = slugify(category.name).toLowerCase();
  
                        if (String(parsed.category).toLowerCase() === slugifiedCatName) {
                            selectedCategory = i

                            this.getCatInView(i)
                        }
                        return 0;
                    });
                }

        }
        catch (err) {
        }

        this.calculateCompliancePercentage(selectedHighLevelCategory ?
            Number(selectedHighLevelCategory.numberOfCompliantControls + selectedHighLevelCategory.numberOfNotApplicableControls) :
            Number(pageData.compliantControlsTotal + pageData.notApplicableControlsTotal), pageData.totalControls)
        this.setState({
            categories: pageData.categories.sort(this.sortCardsAlphabetically).slice(0),
            highLevelCategory: highLevelCategory ? highLevelCategory : '',
            humanHighLevelCategory: selectedHighLevelCategory ? selectedHighLevelCategory.name : '',
            lowLevelCategory: pageData.categories.sort(this.sortCardsAlphabetically)[selectedCategory].name.toLowerCase(),
            isFlat: !highLevelCategory,
            selectedCategory: selectedCategory,
            loading: false
        })
    }

    calculateCompliancePercentage = (compliant, total) => {
        this.setState({
            compliantControlsTotal: compliant,
            totalControls: total > -1 ? total : 0,
            categoryCompliance: total > 0 ? Number(((compliant / total) * 100).toFixed(0)) : 0
        })
    }

    addCompliant = (category) => {
        let currentState = Object.assign({}, this.state)
        let newCategories = []
        currentState.categories.forEach(c => {
            let _c = Object.assign({}, c)
            if (_c.name.toLowerCase() === category) {
                _c.numberOfCompliantControls += 1
            }
            newCategories.push(_c)
        })
        currentState.categories = newCategories
        currentState.compliantControlsTotal = currentState.compliantControlsTotal + 1
        currentState.categoryCompliance = currentState.totalControls > 0 ?
            Number(((currentState.compliantControlsTotal / currentState.totalControls) * 100).toFixed(0)) :
            0

        return this.setState({ ...currentState })
    }

    subtractCompliant = (category) => {
        let currentState = Object.assign({}, this.state)
        let newCategories = []
        currentState.categories.forEach(c => {
            let _c = Object.assign({}, c)
            if (_c.name.toLowerCase() === category) {
                _c.numberOfCompliantControls -= 1
            }
            newCategories.push(_c)
        })
        currentState.categories = newCategories
        currentState.compliantControlsTotal = currentState.compliantControlsTotal - 1 > -1 ?
            currentState.compliantControlsTotal - 1 :
            0
        currentState.categoryCompliance = currentState.totalControls > 0 ?
            Number(((currentState.compliantControlsTotal / currentState.totalControls) * 100).toFixed(0)) :
            0

        return this.setState({ ...currentState })
    }

    addNotApplicable = (category) => {
        let currentState = Object.assign({}, this.state)
        let newCategories = []
        currentState.categories.forEach(c => {
            let _c = Object.assign({}, c)
            if (_c.name.toLowerCase() === category) {
                _c.numberOfNotApplicableControls = _c.numberOfNotApplicableControls + 1
            }
            newCategories.push(_c)
        })

        currentState.categories = newCategories
        //currentState.totalControls = currentState.totalControls - 1 > -1 ? currentState.totalControls - 1 : 0
        currentState.compliantControlsTotal = currentState.compliantControlsTotal + 1 <= currentState.totalControls ?
        currentState.compliantControlsTotal + 1 : currentState.compliantControlsTotal
        currentState.categoryCompliance = currentState.totalControls > 0 ?
            Number(((currentState.compliantControlsTotal / currentState.totalControls) * 100).toFixed(0)) :
            0

        return this.setState({ ...currentState })
    }

    subtractNotApplicable = (category) => {
        let currentState = Object.assign({}, this.state)
        let newCategories = []
        currentState.categories.forEach(c => {
            let _c = Object.assign({}, c)
            if (_c.name.toLowerCase() === category) {
                if (_c.numberOfNotApplicableControls > 0) {
                    _c.numberOfNotApplicableControls =  _c.numberOfNotApplicableControls - 1
                } else {
                    _c.numberOfNotApplicableControls = 0
                }
            }
            newCategories.push(_c)
        })

        currentState.categories = newCategories
        //currentState.totalControls = currentState.totalControls - 1
        currentState.compliantControlsTotal = currentState.compliantControlsTotal - 1 > -1 ?
        currentState.compliantControlsTotal - 1 :
        0
        currentState.categoryCompliance = currentState.totalControls > 0 ?
            Number(((currentState.compliantControlsTotal / currentState.totalControls) * 100).toFixed(0)) : 0

        return this.setState({ ...currentState })
    }

    handleStatusChange = async (oldValue, newValue, lowLevelCategory) => {

        if (oldValue !== 1 && newValue === 1) {
            await this.addCompliant(lowLevelCategory)
        } else if (oldValue === 1 && newValue !== 1) {
            await this.subtractCompliant(lowLevelCategory)
        }

        if (oldValue !== 4 && newValue === 4) {
            await this.addNotApplicable(lowLevelCategory)
        }
        else if (oldValue === 4 && newValue !== 4) {
            await this.subtractNotApplicable(lowLevelCategory)
        }
    }

    render () {
        const {
            loaded, loading, navigationStyle,
            categories, compliantControlsTotal, totalControls,
            frameworkName, headingDescription, highLevelCategory
        } = this.props;

        let selectedHighLevelCategory = null

        let pageData = {
            compliantControlsTotal: compliantControlsTotal,
            totalControls: totalControls,
            subHeading: headingDescription,
            title: frameworkName + ' Controls',
            notApplicableControlsTotal: 0
        }

        if (highLevelCategory) {
            selectedHighLevelCategory = categories.find(c => slugify(c.name.toLowerCase()) === highLevelCategory);
            if (selectedHighLevelCategory) {
                //we redefine the page data to be the specific category
                // pageData.categories = selectedHighLevelCategory.categories
                pageData.compliantControlsTotal = selectedHighLevelCategory.numberOfCompliantControls || 0
                pageData.notApplicableControlsTotal = selectedHighLevelCategory.numberOfNotApplicableControls || 0
                pageData.totalControls =
                    selectedHighLevelCategory.numberOfControls
                pageData.subHeading = selectedHighLevelCategory.description
                pageData.title = selectedHighLevelCategory.name + ' Controls'
            }
        } else {
            pageData.totalControls =
                categories.reduce((prevNumberOfControls, currentCategory) =>
                    prevNumberOfControls +
                    (currentCategory.numberOfControls), 0)
            pageData.compliantControlsTotal =
                categories.reduce((prevNumberOfCompliantControls, currentCategory) =>
                    prevNumberOfCompliantControls + currentCategory.numberOfCompliantControls, 0)
            pageData.notApplicableControlsTotal =
                categories.reduce((prevNumberOfNotApplicableControls, currentCategory) =>
                    prevNumberOfNotApplicableControls + currentCategory.numberOfNotApplicableControls, 0)
        }

        let backBttn;
        if (this.props.highLevelCategory === undefined){
            backBttn=null
        }
        else{
            backBttn=<button 
            className="button-link"
            onClick={() => this.props.history.push(`/app/compliance/${localStorage.getItem('path')}`)}
            style={{display: localStorage.getItem('status') === 'false' ? 'block' : 'none'}}
        > &#8592; <span style={{textDecoration: 'underline'}}>Back</span></button>
        }
        return (
            <div>
                
                {/* This means the category provided in the URL is invalid */}
                {selectedHighLevelCategory === undefined ? <Redirect to='/app/dashboard' /> : null}
                <Row>
                    {(this.state.loading || !loaded || loading) &&
                        <div
                            className={`custom_load load${(this.state.loading || !loaded || loading) ?
                                '' :
                                ' loaded'}`}>
                            <div className='load__icon-wrap'>
                                <svg className='load__icon'>
                                    <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                                </svg>
                            </div>
                        </div>
                    }
                    <Col md={12} id="test">
                        {backBttn}
                        <h3 className='page-title'>{pageData.title}</h3>
                        <h3 className='page-subhead subhead'>{pageData.subHeading}</h3>
                    </Col>
                    <Col style={{ paddingRight: '70px', minWidth: '950px' }}>

                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div id="staticComplianceCard" style={{ marginRight: 20 }}>
                                <ComplianceCard
                                    title="Compliance Status"
                                    percentage={this.state.categoryCompliance}
                                    numberCompliance={this.state.compliantControlsTotal}
                                    totalControls={this.state.totalControls}
                                    clickable={false}
                                    percentage_color={this.state.compliantControlsTotal === 0 ?
                                        "#C6C6C6" : '#2d9aa6'}
                                    bgColor="no-bg"
                                    isPercentage
                                    styles={{ marginTop: '25px' }}
                                />
                            </div>

                            <div className="arrow-left" style={{ display: loading ? 'none' : 'initial' }}>
                                <div
                                    style={navigationStyle}
                                    onClick={() => this.scrollContent('left')}>
                                    <ChevronLeft id='scrollUp' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>

                            <div
                                id='card-content'
                                style={{ display: 'flex', flexDirection: 'row', overflowY: 'scroll' }}>
                                {this.renderSlideCards()}
                            </div>

                            <div className="arrow-right" style={{ display: loading ? 'none' : 'initial' }}>
                                <div
                                    style={navigationStyle}
                                    onClick={() => this.scrollContent('right')}>
                                    <ChevronRight id='scrollDown' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>
                        </div>

                    </Col>

                    <Control
                        title={`${pageData.title} Compliance`}
                        categories={[this.state.categories.sort(this.sortCardsAlphabetically)[this.state.selectedCategory]]}
                        parse={this.props.parse}
                        frameworkId={this.props.frameworkId}
                        update={this.state.updateGrid}
                        setUpdate={this.setUpdate}
                        selectedCatName={this.state.categories.sort(this.sortCardsAlphabetically)[this.state.selectedCategory]}
                        highLevelCategory={this.state.highLevelCategory}
                        humanHighLevelCategory={this.state.humanHighLevelCategory}
                        lowLevelCategory={this.state.lowLevelCategory}
                        framework={this.props.urlFrameworkName}
                        isFlat={this.state.isFlat}
                        handleStatusChange={this.handleStatusChange}
                        layout={this.props.layout}
                        subhead={this.state.categories.sort(this.sortCardsAlphabetically)[this.state.selectedCategory] ?
                            this.state.categories.sort(this.sortCardsAlphabetically)[this.state.selectedCategory].description :
                            null}
                    />

                </Row>
            </div >

        )
    }
}

function mapStateToProps (state) {
    return {
        summary: state.controlsData.summary
    }
}

export default withRouter(connect(mapStateToProps)(LowLevelCategories))


// WEBPACK FOOTER //
// ./src/components/compliance/components/LowLevelCategories.js